export const OVERVIEW = '/'
export const RIDERS = '/riders'
export const ACCIDENT_REPORTS = '/accident-reports'
export const HUNTERS = '/hunters'
export const ORG = '/organization'
export const CREATE_ORG = '/create-organization'
export const VEHICLES = '/vehicles'
export const PARKING_PHOTO_LABELLING = '/parking-photo-labelling'
export const SAFETY_CONTROL_SYSTEM = '/safety-control-system'
export const VMAP = '/vehicle-map'
export const ZONES = '/zones'
export const LOGIN = '/login'
export const CAMPAIGNS = '/campaigns'
export const PERMISSIONS = '/permissions'
export const LEGAL = '/legal'
export const REPAIR_MANAGEMENT = '/repairs'
export const ADMINISTRATION = '/administration'
export const VEHICLE_REPORTS = '/vehicle-reports'
export const RIDE_INSPECTOR = '/ride-inspector'
export const WAREHOUSES = '/warehouses'
export const CONFIGHUB = '/confighub'
export const CITYREGS = '/cityregs'
export const MAINTENANCE_NEEDS = '/maintenance-needs'
export const WALLET = '/wallet'
export const PRICING_PORTAL = '/portal/pricing'
export const PARTNER_PORTAL = '/partners'
export const BATTERIES = '/batteries'
export const BATTERY_BULK = '/battery-bulk'
export const WORK_AREAS = '/work-areas'
export const BATTERY_SHIPMENTS = '/battery-shipments'
export const ANALYTICS = '/analytics'
export const VOI_AGENT = '/voi-agent'
export const STATION_CLEANUP_JOBS = '/parking-cleanups'
export const FLEET_CONNECTIVITY = '/fleet-connectivity'
export const ROUTING = '/routing'
export const ROUTING_HEX_SNAPS = '/routing/hex-snaps'
export const BATTERY_INVENTORY = '/battery-inventory'
